import { useCallback, useEffect, useState } from 'react'

import useI18n from 'hooks/useI18n'
import { ReadCompetitiveIntelligenceAssistants } from 'services/competitive-intelligence'
import { trackEventOnce } from 'services/analytics'
import { apiRequest, exposeStrapiError } from 'utils'

const errorStatus = result => Number(result?.error?.status || 0)

export default function useController() {
  const { t } = useI18n()
  const [state, setState] = useState({ status: 'loading', assistants: [], ownerLabel: '' })
  const load = useCallback(async () => {
    setState({ status: 'loading', assistants: [], ownerLabel: '' })
    const result = await apiRequest(ReadCompetitiveIntelligenceAssistants)
    if (!result || result?.error) {
      const code = errorStatus(result)
      if (result?.error && ![401, 403].includes(code)) exposeStrapiError(result)
      setState({
        status: [401, 403].includes(code) ? 'denied' : code >= 500 || !result ? 'unavailable' : 'error',
        assistants: [], ownerLabel: '',
      })
      return
    }
    const assistants = Array.isArray(result.data?.items) ? result.data.items : []
    setState({ status: assistants.length ? 'ready' : 'empty', assistants, ownerLabel: result.data?.ownerLabel || '' })
    trackEventOnce('competitive_intelligence_assistants_viewed', {
      competitive_section: 'assistants', assistant_count: assistants.length,
    }, 'assistants-viewed')
  }, [])
  useEffect(() => { load() }, [load])
  return { ...state, retry: load, t }
}
